import usePaxSession from "features/shared/hooks/usePaxSession";

const useAllowedDocumentsForTravelDoc = () => {
  const paxSession = usePaxSession();
  return paxSession
    ? paxSession.checklist.allowedTravelDocumentsSet.allowedDocuments
    : [];
};

export default useAllowedDocumentsForTravelDoc;
